import styled from "@emotion/styled";

const StyledTagsInput = styled.div`
  .MuiChip-root {
    background-color: var(--cms-selected-bg);
    color: var(--cms-text-primary);
    font-size: 14px;
    margin: 4px;
    
    .MuiChip-deleteIcon {
      color: var(--cms-text-secondary);
      
      &:hover {
        color: var(--cms-text-primary);
        transition: ease-in-out 0.2s;
      }
    }
  }
  
  .MuiTextField-root {
    .MuiInput-root {
      font-size: 14px;
      
      &::placeholder {
        color: var(--cms-text-secondary);
      }
    }
  }
`;

export { StyledTagsInput };
